<template>
  <div
    id="app"
    v-bind:class="`${vista} in-iframe-${inIframe} ${adobeTargetExperience}`"
  >
    <top-bar v-if="!inIframe"></top-bar>
    <div v-show="!loading" class="router-container" :inert="inertMainContent">
      <router-view />
    </div>
    <app-footer
      v-if="!loading && footerText"
      :text="footerText"
      :theme="footerTheme"
      :legalText="legalText"
    ></app-footer>
    <LoaderGeneral v-if="loading" />
    <embed-veridas
      v-if="config.isVeridasActive && m_preloadSdk"
      :inert="!inertMainContent"
      :valueIframe="iframeData"
      @close="closeModal"
    ></embed-veridas>
    <notification-toast />
  </div>
</template>

<script>
import TopBar from "@/components/core/TopBar";
import AppFooter from "@/components/core/AppFooter";
import NotificationToast from "@/components/core/NotificationToast";
import _get from "lodash/get";
import EmbedVeridas from "@/components/core/custom/EmbedVeridas";
import LoaderGeneral from "@/components/core/LoaderGeneral";
import { mapState } from "vuex";

export default {
  name: "App",
  components: {
    TopBar,
    AppFooter,
    LoaderGeneral,
    NotificationToast,
    EmbedVeridas
  },
  data() {
    return {
      vista: null,
      inIframe: true
    };
  },
  methods: {
    closeModal() {
      //debe llamarse desde la raiz para leer document
      this.hideVeridasSdk();
    }
  },
  computed: {
    ...mapState({
      iframeData: state => {
        return state.DVSIframeData;
      }
    }),
    isCliente() {
      return this.$store.getters.esCliente();
    },
    loading() {
      return this.$store.state.isLoading;
    },
    legalText() {
      const pasoLegal = this.config.pasos[this.vista]
        ? this.config.pasos[this.vista].legalText
        : null;
      if (pasoLegal === null) return null;
      return pasoLegal || _get(this.config, "legalText", null);
    },
    footerText() {
      let pasoFooter = this.config.pasos[this.vista]
        ? this.config.pasos[this.vista].footerText
        : null;
      if (pasoFooter === null) {
        return null;
      }
      let footerText = pasoFooter || _get(this.config, "footerText", null);
      return footerText;
    },
    footerTheme() {
      return this.config.pasos[this.vista]
        ? this.config.pasos[this.vista].footerTheme
        : null;
    },
    inertMainContent() {
      return this.m_isIframeSdkVisible;
    }
  },
  mounted() {
    this.inIframe = window.top != window.self;
    this.$store.watch(
      this.$store.getters.getRoute,
      route => {
        // Obtengo el name de la vista para agregar clase general al div#app
        this.vista = route.name;
      },
      { immediate: true }
    );
  }
};
</script>

<style>
#app {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  min-width: 100%;
  width: 100%;
}

body {
  margin: auto;
}

.router-container {
  padding: 80px 17px 0;
  min-height: calc(100vh - 80px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.in-iframe-true .router-container {
  padding-top: 0 !important;
}

/* Estilos globales para cada paso usando la clase con el nombre de la ruta */
#app.gracias,
#app.final {
  background: #043263;
  /* HACK: Problema con overflow por no poder
  dar color de fondo al body
  doy scroll al elemento #app */
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

#app.final.in-iframe-true,
#app.gracias.in-iframe-true {
  position: relative !important;
}

#app.graciasPH {
  background: #f4f4f4;
}

#app.graciasPH .router-container,
#app.consulta:has(.calculadoras-container) .router-container {
  padding: 48px 0 0;
}

#app.asesoramiento {
  background: white;
}

@media screen and (min-width: 420px) {
  #app.graciasPH .router-container,
  #app.consulta:has(.calculadoras-container) .router-container {
    padding: 64px 0 0;
  }
}
@media screen and (min-width: 600px) {
  .router-container {
    /*El padding top debe incluir la top bar + padding de contenedor y dar una distancia de 60 px
    entre el topbar y el primer título
    padding = altura top bar - 17px + 60px;
    */
    padding: 103px 0 0;
  }
}

@media screen and (min-width: 772px) {
  #app.asesoramiento {
    background: linear-gradient(
      to right,
      white 0,
      white 55%,
      #d4edfc 55%,
      #d4edfc 100%
    );
  }
}
</style>
